import { render, staticRenderFns } from "./gpb-chart.vue?vue&type=template&id=4479ef05&scoped=true&"
import script from "./gpb-chart.vue?vue&type=script&lang=js&"
export * from "./gpb-chart.vue?vue&type=script&lang=js&"
import style0 from "./gpb-chart.vue?vue&type=style&index=0&id=4479ef05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479ef05",
  null
  
)

export default component.exports